import { makeStyles } from "@material-ui/core"

import { themeColors } from "letalkui"

const useStyles = makeStyles({
	container: {
		maxWidth: 900,
		padding: 24,
		border: "1px solid",
		borderColor: themeColors.colors.system.gray[200]
	},
	loadingContainer: {
		minHeight: 300
	}
})

export default useStyles
